import type { LicenseRow } from "../api/client";

export const DAY = 86_400_000;

export function daysLeft(iso: string): number {
  return Math.ceil((new Date(iso).getTime() - Date.now()) / DAY);
}

export function fmtDate(iso: string | undefined | null): string {
  if (!iso) return "—";
  return new Date(iso).toLocaleDateString("pl-PL", { day: "2-digit", month: "short", year: "numeric" });
}

/** Visual status: surfaces "expiring" (≤30 days) and date-based expiry on top of the backend status. */
export function visualStatus(lic: LicenseRow): { key: string; label: string } {
  if (lic.status === "revoked") return { key: "revoked", label: "cofnięta" };
  if (lic.status === "reactivate") return { key: "expiring", label: "ponowna aktywacja" };
  if (lic.status === "expired" || daysLeft(lic.expiresAt) <= 0) return { key: "expired", label: "wygasła" };
  if (lic.status === "issued") return { key: "issued", label: "wydana" };
  if (daysLeft(lic.expiresAt) <= 30) return { key: "expiring", label: "wygasa wkrótce" };
  return { key: "active", label: "aktywna" };
}
